import React, { createContext, useContext, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import { useCookies } from './CookieContext';

interface AnalyticsContextType {
  trackEvent: (category: string, action: string, label?: string) => void;
  trackPageView: (path: string) => void;
}

const AnalyticsContext = createContext<AnalyticsContextType>({
  trackEvent: () => {},
  trackPageView: () => {},
});

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { cookieConsent } = useCookies();

  useEffect(() => {
    if (cookieConsent?.analytics) {
      ReactGA.initialize('G-XXXXXXXXXX'); // Replace with your GA4 measurement ID
    }
  }, [cookieConsent?.analytics]);

  useEffect(() => {
    if (cookieConsent?.analytics) {
      ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
    }
  }, [location, cookieConsent?.analytics]);

  const trackEvent = (category: string, action: string, label?: string) => {
    if (cookieConsent?.analytics) {
      ReactGA.event({
        category,
        action,
        label
      });
    }
  };

  const trackPageView = (path: string) => {
    if (cookieConsent?.analytics) {
      ReactGA.send({ hitType: 'pageview', page: path });
    }
  };

  return (
    <AnalyticsContext.Provider value={{ trackEvent, trackPageView }}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export const useAnalytics = () => useContext(AnalyticsContext);